function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["innerHTML"];
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
import { debounce } from "@utils/functionUtils";
import { ref, watch, onBeforeMount, computed } from "vue";
import SelectItem from "@vueEntry/UIKitComponents/BaseSelect/SelectItem.vue";
import { useKeyboardController } from "@wkComposables/useKeyboardController";
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAutocomplete',
  props: /*#__PURE__*/_mergeModels({
    border: {
      type: Boolean,
      "default": true
    },
    isValid: {
      "default": null
    },
    theme: {
      "default": ""
    },
    label: {
      "default": ""
    },
    disableCb: {
      type: Boolean,
      "default": false
    },
    onInputChangeCb: {},
    onOptionSelectedCb: {
      "default": null
    },
    manualClose: {
      type: Boolean,
      "default": false
    },
    keepState: {
      "default": null
    }
  }, {
    "modelValue": {
      "default": function _default() {
        return {
          id: "",
          label: ""
        };
      }
    },
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["dropdownClosed", "changedValue", "click"], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var _this = this;
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    /** The modelValue holds the value of one of the selectItems. If empty, it means that no selectItem has been selected */
    var modelValue = _useModel(__props, "modelValue");
    var emits = __emit;
    var curValue = ref("");
    var options = ref([]);
    var debouncedCallback = ref(null);
    var selection = ref(false);
    var openDropdown = ref(false);
    var baseInput = ref(null);
    var optionsLength = computed(function () {
      return options.value.length;
    });
    onBeforeMount(function () {
      var _a;
      curValue.value = ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.label) || "";
      debouncedCallback.value = debounce({
        delay: 300
      }, props.onInputChangeCb);
    });
    var _useKeyboardControlle = useKeyboardController({
        optionsLength: optionsLength,
        isDropdownOpen: openDropdown,
        disableSpaceHandler: true
      }),
      activeIdx = _useKeyboardControlle.activeIdx,
      selectedIdx = _useKeyboardControlle.selectedIdx;
    var inputClasses = computed(function () {
      switch (props.theme) {
        case "bordered":
          return "";
        case "all-bordered":
          return "tw-rounded " + (openDropdown.value && "tw-rounded-b-none");
        case "all-bordered-thick":
          return "tw-rounded-xl !tw-h-[60px] " + (openDropdown.value && "tw-rounded-b-none");
        default:
          return "";
      }
    });
    var fieldsetClasses = computed(function () {
      switch (props.theme) {
        case "bordered":
          return "";
        case "all-bordered":
          return "tw-border tw-border-w-lavender tw-border-solid tw-rounded " + (openDropdown.value ? "tw-border-b-0 tw-rounded-b-none" : "");
        case "all-bordered-thick":
          return "tw-rounded-xl !tw-h-[60px]" + (openDropdown.value && "tw-rounded-b-none");
        default:
          return "";
      }
    });
    var themeClasses = computed(function () {
      var commonThickClasses = "tw-rounded-b-xl tw-shadow " + "tw-rounded-t-none " + "tw-mb-0 !tw-mt-0 tw-text-w-black " + "!tw-rounded-b-xl !tw-rounded-t-none";
      switch (props.theme) {
        case "bordered":
          //bordered classes
          return "before:tw-content-[''] before:tw-absolute before:tw-w-1/2 " + "before:tw-border-b before:tw-border-b-w-lavender before:[border-bottom-style:solid] before:tw-right-1/4 " + "tw-rounded-b-xl tw-shadow " + "tw-rounded-t-none tw-mt-5px tw-mb-0";
        case "all-bordered":
          return commonThickClasses;
        case "all-bordered-thick":
          return commonThickClasses;
        default:
          return "";
      }
    });
    var handleChangedValue = function handleChangedValue(v) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(curValue.value === v)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              emits("changedValue", v);
              curValue.value = v;
              if (props.onInputChangeCb) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              // If there is no value, we will update the modelValue
              if (modelValue.value && !v) {
                modelValue.value.label = "";
                openDropdown.value = false;
              }
              /* In case the input is null, empty or we have selected an optionItem, we clean up the options array */
              if (!(!v || selection.value)) {
                _context.next = 15;
                break;
              }
              options.value = [];
              selection.value = false;
              selectedIdx.value = -1;
              activeIdx.value = -1;
              //Invalidating the callback
              _context.next = 14;
              return debouncedCallback.value(null);
            case 14:
              return _context.abrupt("return");
            case 15:
              if (!props.disableCb) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("return");
            case 17:
              _context.next = 19;
              return debouncedCallback.value(v);
            case 19:
              options.value = _context.sent;
              //Opening the dropdown iff there is something to show
              if (options.value.length) openDropdown.value = true;
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    var handleSelection = function handleSelection(opt, optIdx) {
      if (props.onOptionSelectedCb) props.onOptionSelectedCb(opt);
      selection.value = true;
      curValue.value = opt.label;
      //Triggering event update:modelValue
      modelValue.value = opt;
      //Closing the dropdown
      openDropdown.value = false;
      selectedIdx.value = optIdx;
    };
    var openDropdownWithOptions = function openDropdownWithOptions() {
      if (!options.value.length) return;
      if (props.keepState === "closed") return;
      openDropdown.value = true;
    };
    watch(modelValue, function (cur, prev) {
      if (cur === prev) return;
      curValue.value = (cur === null || cur === void 0 ? void 0 : cur.label) || "";
    });
    watch(selectedIdx, function (curIdx) {
      var _a;
      if (curIdx === -1) return;
      var optionSelected = options.value[curIdx];
      /* In case we select the same option as before, we will do nothing */
      if (selection.value && optionSelected.label === ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.label)) return;
      handleSelection(optionSelected, curIdx);
    });
    watch(function () {
      return props.manualClose;
    }, function (cur) {
      if (!cur) return;
      //Cleaning up the options just when the user has selected an option!
      if (selection.value) options.value = [];
      emits("dropdownClosed");
    });
    var select = function select() {
      var _a;
      (_a = baseInput.value) === null || _a === void 0 ? void 0 : _a.select();
    };
    __expose({
      select: select
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(BaseDropDown, {
        "class": _normalizeClass(_ctx.$attrs['root-classes']),
        "data-cy": "ac_".concat(_ctx.$attrs['data-cy']),
        "dropdown-element": "ul",
        "dropdown-classes": [{
          'bordered-dropdown': _ctx.theme === 'bordered'
        }, {
          'all-bordered-dropdown': _ctx.theme === 'all-bordered'
        }, {
          'all-bordered-dropdown thick': _ctx.theme === 'all-bordered-thick'
        }, {
          'tw-mt-10px !tw-border !tw-border-w-secondary !tw-rounded-xs': !_ctx.theme
        }, themeClasses.value, '!tw-max-h-[210px] tw-z-10', _ctx.$attrs['dropdown-classes']],
        "open-dropdown": openDropdown.value,
        "keep-state": !options.value.length ? 'closed' : '',
        "onUpdate:dropdownState": _cache[0] || (_cache[0] = function (v) {
          return openDropdown.value = v;
        }),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          emits('click');
          openDropdownWithOptions();
        })
      }, {
        btn_slot: _withCtx(function () {
          var _a;
          return [_createVNode(BaseInput, {
            id: "ac_input_".concat(_ctx.$attrs.id),
            ref_key: "baseInput",
            ref: baseInput,
            "data-cy": "ac_input_".concat(_ctx.$attrs.id),
            "label-text": _ctx.label,
            "model-value": ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.label) || '',
            "is-valid": _ctx.isValid,
            disabled: _ctx.$attrs['disabled'],
            placeholder: _ctx.$attrs['placeholder'],
            "with-left-icon": !!_ctx.$slots.lefticon,
            "with-right-icon": !!_ctx.$slots.righticon,
            border: !_ctx.theme,
            radius: !_ctx.theme || _ctx.theme === 'bordered',
            "input-class": [inputClasses.value, _ctx.$attrs['input-classes']],
            "fieldset-classes": [fieldsetClasses.value, _ctx.$attrs['fieldset-classes']],
            "keep-floating-label": !!curValue.value,
            "onUpdate:modelValue": handleChangedValue
          }, {
            leftIcon: _withCtx(function () {
              return [_renderSlot(_ctx.$slots, "lefticon")];
            }),
            righticon: _withCtx(function (_ref2) {
              var handleClean = _ref2.handleClean;
              return [_renderSlot(_ctx.$slots, "righticon", {
                handleClean: handleClean
              })];
            }),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["id", "data-cy", "label-text", "model-value", "is-valid", "disabled", "placeholder", "with-left-icon", "with-right-icon", "border", "radius", "input-class", "fieldset-classes", "keep-floating-label"])];
        }),
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, function (option, idx) {
            return _openBlock(), _createBlock(SelectItem, {
              key: idx,
              active: _unref(activeIdx) === idx,
              "class": "tw-py-10px tw-px-5 tw-m-1 tw-rounded-[5px] hover:tw-cursor-pointer",
              onClick: function onClick($event) {
                return handleSelection(option, idx);
              },
              onMouseover: function onMouseover($event) {
                return activeIdx.value = idx;
              }
            }, {
              "default": _withCtx(function () {
                return [_createElementVNode("span", {
                  innerHTML: option.label
                }, null, 8 /* PROPS */, _hoisted_1)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "onClick", "onMouseover"]);
          }), 128 /* KEYED_FRAGMENT */))];
        }),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["class", "data-cy", "dropdown-classes", "open-dropdown", "keep-state"]);
    };
  }
});